import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, PauseCircle, Calendar } from 'lucide-react';
import { Loan } from '../data/mockLoans';
interface SnoozeModalProps {
  isOpen: boolean;
  loan: Loan | null;
  onClose: () => void;
  onSubmit: (snoozeUntil: string) => void;
}
export function SnoozeModal({
  isOpen,
  loan,
  onClose,
  onSubmit
}: SnoozeModalProps) {
  const [snoozeUntil, setSnoozeUntil] = useState('');
  useEffect(() => {
    if (isOpen) {
      setSnoozeUntil('');
    }
  }, [isOpen]);
  if (!isOpen || !loan) return null;
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (snoozeUntil) {
      onSubmit(snoozeUntil);
    }
  };
  return <AnimatePresence data-id="element-140">
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4" style={{
      backgroundColor: 'rgba(42, 42, 42, 0.5)',
      backdropFilter: 'blur(4px)'
    }} data-id="element-141">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} className="bg-white rounded-2xl shadow-2xl w-full max-w-md overflow-hidden border border-stone-200" data-id="element-142">
          <div className="flex items-center justify-between px-6 py-4 border-b border-stone-100 bg-stone-50/50" data-id="element-143">
            <h2 className="text-lg font-semibold text-stone-900 flex items-center gap-2" data-id="element-144">
              <PauseCircle className="w-5 h-5 text-amber-500" data-id="element-145" />
              Snooze: {loan.borrowerName}
            </h2>
            <button onClick={onClose} className="p-2 text-stone-400 hover:text-stone-600 hover:bg-stone-100 rounded-full transition-colors" data-id="element-146">
              <X className="w-5 h-5" data-id="element-147" />
            </button>
          </div>

          <form onSubmit={handleSubmit} className="p-6 space-y-6" data-id="element-148">
            <p className="text-sm text-stone-600" data-id="element-149">
              This loan will be removed from your current queue and will
              reappear at the scheduled time.
            </p>

            <div data-id="element-150">
              <label className="block text-sm font-medium text-stone-700 mb-2 flex items-center gap-2" data-id="element-151">
                <Calendar className="w-4 h-4 text-stone-400" data-id="element-152" />
                Snooze Until <span className="text-rose-500" data-id="element-153">*</span>
              </label>
              <input type="datetime-local" value={snoozeUntil} onChange={e => setSnoozeUntil(e.target.value)} className="w-full px-4 py-2.5 rounded-xl border border-stone-200 outline-none transition-all text-stone-700" onFocus={e => {
              e.currentTarget.style.borderColor = '#C5A55A';
              e.currentTarget.style.boxShadow = '0 0 0 3px rgba(197, 165, 90, 0.15)';
            }} onBlur={e => {
              e.currentTarget.style.borderColor = '#d6d3d1';
              e.currentTarget.style.boxShadow = 'none';
            }} data-id="element-154" />
            </div>

            <div className="pt-4 flex gap-3 border-t border-stone-100" data-id="element-155">
              <button type="button" onClick={onClose} className="flex-1 py-2.5 px-4 rounded-xl border border-stone-200 text-stone-700 font-medium hover:bg-stone-50 transition-colors" data-id="element-156">
                Cancel
              </button>
              <button type="submit" disabled={!snoozeUntil} className="flex-1 py-2.5 px-4 rounded-xl text-white font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed" style={{
              backgroundColor: '#d97706'
            }} onMouseEnter={e => {
              if (snoozeUntil) e.currentTarget.style.backgroundColor = '#b45309';
            }} onMouseLeave={e => {
              e.currentTarget.style.backgroundColor = '#d97706';
            }} data-id="element-157">
                Snooze Loan
              </button>
            </div>
          </form>
        </motion.div>
      </div>
    </AnimatePresence>;
}